/* eslint-disable react/button-has-type */
import cx from "classnames";
import React from "react";

import { useBreakpoints } from "@/hooks/use-breakpoints";

import { openModal } from "@/services/modalsProvider";
import { MODAL_NAMES } from "@/utils/constants";

import css from "./auth-button.module.scss";

// type Props = {
//   children?: string;
//   className?: string;
//   onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
//   disabled?: boolean;
//   type?: 'button' | 'submit' | 'reset';
//   invert?: boolean;
//   userName?: string;
//   state?: 'empty' | 'pending' | 'done' | 'error';
// };

const AuthButton = ({
  children = "Начать",
  onClick,
  disabled,
  type = "button",
  invert,
  className,
  noModal,
}) => {
  const bps = useBreakpoints();

  if (!bps.isComputed) {
    return null;
  }

  const handleClick = (e) => {
    if (!noModal) {
      openModal({
        id: MODAL_NAMES.auth,
        modalName: MODAL_NAMES.auth,
      });
    }
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  return (
    <button
      className={cx(
        css.authButton,
        { [css.disabled]: disabled, [css.invert]: invert },
        className
      )}
      onClick={handleClick}
      type={type}
    >
      {children}
    </button>
  );
};

export default AuthButton;
